import React, { useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
import DropdownMenu from '../DropdownMenu';
import Button from '../Button/button';
import { LogControlName } from '../../utils/log.utils';
import { useCreateLogApi } from '../../hooks/api/log.hook';
import AGUtils from '../../utils/ag-grid.utils';

export interface DownloadTableButtonProps<T> {
  className?: string;
  style?: React.CSSProperties;
  tableRef: React.RefObject<AgGridReact<T>>;
  columnsToExport?: string[];
  logFormName?: string;
  sheetName?: string;
  excludeColIds?: string[];
  exportFeatureName: string;
}

const dropdownItems = [
  { text: 'CSV', value: 'csv' },
  { text: 'Excel', value: 'excel' },
];

export default function ButtonTableDownload<T>({
  className, style, tableRef, columnsToExport, logFormName, sheetName, excludeColIds, exportFeatureName,
}: DownloadTableButtonProps<T>) {
  const { request: createLog } = useCreateLogApi();

  // Export default columns or columns passed by props, to avoid exporting unnecessary columns.
  const allColumns = tableRef.current?.columnApi?.getColumns();
  const columns = columnsToExport || allColumns?.map((column) => column.getColId()).filter((colId) => !excludeColIds?.includes(colId));

  const downloadOptions = useCallback((type: string) => {
    if (logFormName) createLog(logFormName, LogControlName.Download);
    const fileNameDownload = AGUtils.exportFileName(exportFeatureName);
    if (type === 'excel') tableRef.current?.api.exportDataAsExcel({ fileName: fileNameDownload, columnKeys: columns, sheetName });
    else if (type === 'csv') tableRef.current?.api.exportDataAsCsv({ fileName: fileNameDownload, columnKeys: columns });
  }, [tableRef.current]);

  return (
    <div className={className} style={style}>
      <DropdownMenu options={dropdownItems} left onSelect={downloadOptions}>
        <Button size="smaller" color="lighterGray">ダウンロード</Button>
      </DropdownMenu>
    </div>
  );
}
